import { CheckoutOrderInfo, GQL_ID } from '@@types'
import { gql, useLazyQuery, useQuery } from '@apollo/client'

export type InitializeOrderQuery = {
  initializeOrder: CheckoutOrderInfo | null
}

export type InitializeOrderVariables = {
  shop_id: GQL_ID
}

export const GQL_QUERY_INITIALIZE_ORDER = gql`
  query initializeOrder ($shop_id: ID!) {
    initializeOrder(shop_id: $shop_id) {
      id
      business_profile_id
      uuid
      shop_id
      status
      step
      total
      delivery_total
      address
      comment
      customer_phone
      customer_geoposition {
        latitude
        longitude
      }
      address_appartments
      address_intercom
      address_porch
      address_floor
      door_delivery
      receipt_email
      assembly_method
      slot_id
      deliveryType
      recipientInfo {
        phone
        firstName
        lastName
      }
      totalCashback
      totalDiscount
      customerCourierMessage
      payment_id
      paymentMethod {
        id
        type
        card
        last
        country
      }
    }
  }
`

export const useFetchInitializeOrder = (variables: InitializeOrderVariables) =>
  useQuery<InitializeOrderQuery, InitializeOrderVariables>(GQL_QUERY_INITIALIZE_ORDER, {
    variables,
    fetchPolicy: 'network-only',
  })

export const useLazyInitializeOrder = () =>
  useLazyQuery<InitializeOrderQuery, InitializeOrderVariables>(
    GQL_QUERY_INITIALIZE_ORDER,
    { fetchPolicy: 'network-only' },
  )
